import styled, { css } from 'styled-components/macro';

export interface NavigationSectionTitleProps {
  /** The section title. Will be shown in abbreviated fashion if `compact` is `true`. */
  title: string;
  /** If the component should render the full or compact UI. */
  compact: boolean;
}

// Returns the complete name when `compact` is `false`, or an abbreviated name when `compact` is `true`.
function getSectionName(completeName: string, compact: boolean) {
  if (!compact) {
    return completeName;
  }
  return completeName
    .split(' ')
    .map((part) => part[0])
    .join('');
}

const StyledTitle = styled.h2<{ compact: boolean }>`
  color: var(--color-gray-2);
  font-family: var(--font-family-body);
  font-weight: var(--font-weight-medium);
  font-size: 0.6875rem;
  line-height: 1rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: var(--space-3);

  ${({ compact }) =>
    compact &&
    css`
      text-align: center;
    `}
`;

export function NavigationSectionTitle({ title, compact }: NavigationSectionTitleProps) {
  return (
    <StyledTitle aria-label={title} compact={compact}>
      {getSectionName(title, compact)}
    </StyledTitle>
  );
}
